import {
  modifyObj,
  getAll,
  deleteObj,
  getPage,
  getDetail,
  addObj,
  searchByName
} from '@/api/positioningdevicefittingsserv'

export default {
  state: {
    state_PositioningDeviceFittings_ModifyObjResult: null,
    state_PositioningDeviceFittings_GetAllResult: null,
    state_PositioningDeviceFittings_DeleteObjResult: null,
    state_PositioningDeviceFittings_GetPageResult: null,
    state_PositioningDeviceFittings_GetDetailResult: null,
    state_PositioningDeviceFittings_AddObjResult: null,
    state_PositioningDeviceFittings_SearchByNameResult: null
  },
  mutations: {
    SET_POSITIONINGDEVICEFITTINGS_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_ModifyObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_GetAllResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_DeleteObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_GetPageResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_GetDetailResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_AddObjResult = rst
    },
    SET_POSITIONINGDEVICEFITTINGS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PositioningDeviceFittings_SearchByNameResult = rst
    }
  },
  actions: {
    PositioningDeviceFittingsServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceFittingsServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICEFITTINGS_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICEFITTINGS_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_PositioningDeviceFittings_ModifyObjResult: state => {
      return state.state_PositioningDeviceFittings_ModifyObjResult
    },
    get_PositioningDeviceFittings_GetAllResult: state => {
      return state.state_PositioningDeviceFittings_GetAllResult
    },
    get_PositioningDeviceFittings_DeleteObjResult: state => {
      return state.state_PositioningDeviceFittings_DeleteObjResult
    },
    get_PositioningDeviceFittings_GetPageResult: state => {
      return state.state_PositioningDeviceFittings_GetPageResult
    },
    get_PositioningDeviceFittings_GetDetailResult: state => {
      return state.state_PositioningDeviceFittings_GetDetailResult
    },
    get_PositioningDeviceFittings_AddObjResult: state => {
      return state.state_PositioningDeviceFittings_AddObjResult
    },
    get_PositioningDeviceFittings_SearchByNameResult: state => {
      return state.state_PositioningDeviceFittings_SearchByNameResult
    }
  }
}
